<template>
  <v-card class="card" elevation="24">
    <v-row dense class="justify-center align-center no-gutters">
      <v-col dense cols="auto">
        <RadioButton
          :model-value="resCardSelected"
          @update:modelValue="$emit('toggle', resCardReservation)"
        />
      </v-col>
      <v-col dense cols="auto">
        <FavoriteButton
          :favBtnIsFavorite="resCardReservation.isFavorite"
          :favBtnSeatID="resCardReservation.seat.id"
          :favBtnFavoriteID="resCardReservation.favoriteID"
          @updateFavorite="this.$emit('updateFavorite')"/>
      </v-col>
      <v-col cols="auto">
        <v-icon class="icon-fixed" :style="{ visibility: resCardReservation.comment ? 'visible' : 'hidden' }"color="blue">mdi-comment</v-icon>
      </v-col>
      <v-col dense cols="2">
          <div class="titleWrapper">
            <v-card-title class="seat-title">{{ resCardReservation.seat.description }}</v-card-title>
            <v-card-subtitle class="seat-subtitle">{{resCardReservation.seat.premises + ' Platz ' + resCardReservation.seat.name }}</v-card-subtitle>
          </div>
      </v-col>
      <v-col dense cols="auto">
        <v-card class="dateCard align-center justify-center" elevation="12">
            <v-card-text class="txtDateCard">Zeitraum: {{ resCardStartDate }} - {{ resCardEndDate }}</v-card-text>
        </v-card>
      </v-col>
      <v-col dense cols="auto">
        <v-btn :disabled="!resCardReservation.comment" @click="showDialogComment" variant="elevated" color="blue" prependIcon="mdi-comment" >Kommentar</v-btn>
      </v-col>
      <v-col dense cols="auto">
        <v-btn @click="showDialogSeatPlan" variant="elevated" color="onBackground" prependIcon="mdi-map-outline">Sitzplan</v-btn>
      </v-col>
      <v-col dense cols="auto">
        <v-btn @click="showDialogReservation" variant="elevated" color="#FF7500" prependIcon="mdi-pencil">Reservierung bearbeiten</v-btn>
      </v-col>
      <v-col dense cols="auto">
        <v-btn @click="showDialogResStorno" variant="elevated" color="red" prependIcon="mdi-cancel">Stornieren</v-btn>
      </v-col>
      </v-row>
  </v-card>

  <CommentaryDialog
    ref="commentaryDialogRef"
    :dialogCommentarySeat="resCardReservation.seat"
    :commentary="resCardReservation.comment"/>

  <SeatPlanDialog
    ref="seatPlanDialogRef"
    :dialogSeatPlanImagePath="resPremise ? resPremise.image : ''"
    :dialogSeatPlanSeat="resCardReservation.seat"/>

  <ReservationDialog
    ref="resDialogRef"
    :resDialogReservation="resCardReservation"
    :resDialogUsers="resCardUsers"
    :resDialogStartDate="parseDateToNormal(resCardStartDate)"
    :resDialogEndDate="parseDateToNormal(resCardEndDate)"
    @updateFavorite="this.$emit('updateFavorite')"
    @updateReservation="this.$emit('updateReservation') ; this.$emit('updateOccupancy', resCardReservation.seat)"/>
  
  <ReservationStornoDialog
    ref="resStornoDialogRef"
    :resStornoDialogReservations="resCardReservation"
    @stornoReservation="this.$emit('updateReservation'); this.$emit('updateOccupancy', resCardReservation.seat)"/>
</template>
  
<script>

import FavoriteButton from '../consumables/FavoriteButton.vue'
import SeatPlanDialog from './SeatPlanDialog.vue'
import ReservationDialog from './ReservationDialog.vue'
import ReservationStornoDialog from './ReservationStornoDialog.vue'
import RadioButton from '../consumables/RadioButton.vue'
import CommentaryDialog from './CommentaryDialog.vue'

export default {

  components: {
    FavoriteButton,
    SeatPlanDialog,
    ReservationDialog,
    ReservationStornoDialog,
    RadioButton,
    CommentaryDialog
  },

  props: {
    resCardReservation: {type: Object, default: null},
    resCardUsers: {type: Object, default: null},
    resCardPremises: {type: Object, default: null},
    resCardStartDate: {type: String, required: true},
    resCardEndDate: {type: String, required: true},
    resCardSelected: {type:Boolean, default: false}
  },

  emits: ['updateReservation', 'updateFavorite', 'toggle', 'updateOccupancy'],

  computed: {
    resPremise() {
      if (!this.resCardPremises || !this.resCardReservation) return null
      return this.resCardPremises.find(p => p.shortPrem === this.resCardReservation.seat.locationPath) || null
    }
  },

  methods: {
    showDialogComment() {
      this.$refs.commentaryDialogRef.openDialogCommentary()
    },
    showDialogSeatPlan() {
      this.$refs.seatPlanDialogRef.openDialogSeatPlan()
    },
    showDialogReservation() {
      this.$refs.resDialogRef.openResDialog()
    },
    showDialogResStorno() {
      this.$refs.resStornoDialogRef.openDialogResStorno()
    },
    parseDateToNormal(formattedDate) {
      const [day, month, year] = formattedDate.split('.')
      return `${year}-${month}-${day}`
    },
  },
}
</script>
  
<style scoped>

.card {
  padding: 0 !important;   /* <-- entfernt Standard-Padding */
  margin-bottom: 1rem;
  width: 100%;
  border-radius: 16px;
}
.dateCard {
  display: flex;
  margin: 0.75rem;
  padding: 0 !important;   /* <-- entfernt Standard-Padding */
  border-radius: 4px;
  background-color: rgb(143, 143, 143);
  align-items: center;      
  justify-content: center; 
}
.txtDateCard{
  color: white !important;
  font-weight: 500 !important;
  font-size: large !important;
  padding: 5px 8px !important; /* schön kompakt */
}
.titleWrapper {
  text-align: center;         /* macht beide Texte zentriert */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;        /* falls Vuetify eigene width setzt */
  padding: 0 !important;      /* kein zusätzlicher Abstand */
}
.seat-title{
  padding: 0 !important;
  margin: 0 !important;
}
.seat-subtitle{
  padding: 0 !important;
  margin: 0 !important;
}
</style>